// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/btnCloseLight.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.card-popup_opened {
  visibility: visible;
  opacity: 1;
}

.card-popup__wrapper {
  position: relative;
  background-color: #f7f7f5;
  padding: 7px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.card-popup__img {
  display: block;
  max-height: 75vh;
  max-width: 75vw;
  object-fit: cover;
  cursor: zoom-out;
}

.card-popup__block {
  width: 100%;
  background-color: #f7f7f5;
  padding: 0;
}

.card-popup__title {
  width: 100%;
  font-family: Oswald-Light, sans-serif;
  font-size: 0.7em;
  font-weight: 300;
  color: #073042;
  padding: 10px;
  text-align: start;
  margin: 0;
}

.card-popup__size {
  font-family: Oswald-Light, sans-serif;
  font-size: 0.6em;
  font-weight: 300;
  color: #073042;
  text-align: start;
  margin: 0;
  padding: 0;
  padding-left: 10px;
}

.card-popup__btn-close {
  background-size: 32px;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  position: absolute;
  top: -40px;
  right: -40px;
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
}

@media screen and (max-width: 768px) {
  .card-popup__btn-close {
    right: 0;
  }
  .card-popup__wrapper {
    max-width: 75vw;
    padding: 4px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CardPopup/CardPopup.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,gFAA4E;AAC9E;;AAEA;EACE;IACE,QAAQ;EACV;EACA;IACE,eAAe;IACf,YAAY;EACd;AACF","sourcesContent":[".card-popup {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100vh;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n.card-popup_opened {\r\n  visibility: visible;\r\n  opacity: 1;\r\n}\r\n\r\n.card-popup__wrapper {\r\n  position: relative;\r\n  background-color: #f7f7f5;\r\n  padding: 7px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.card-popup__img {\r\n  display: block;\r\n  max-height: 75vh;\r\n  max-width: 75vw;\r\n  object-fit: cover;\r\n  cursor: zoom-out;\r\n}\r\n\r\n.card-popup__block {\r\n  width: 100%;\r\n  background-color: #f7f7f5;\r\n  padding: 0;\r\n}\r\n\r\n.card-popup__title {\r\n  width: 100%;\r\n  font-family: Oswald-Light, sans-serif;\r\n  font-size: 0.7em;\r\n  font-weight: 300;\r\n  color: #073042;\r\n  padding: 10px;\r\n  text-align: start;\r\n  margin: 0;\r\n}\r\n\r\n.card-popup__size {\r\n  font-family: Oswald-Light, sans-serif;\r\n  font-size: 0.6em;\r\n  font-weight: 300;\r\n  color: #073042;\r\n  text-align: start;\r\n  margin: 0;\r\n  padding: 0;\r\n  padding-left: 10px;\r\n}\r\n\r\n.card-popup__btn-close {\r\n  background-size: 32px;\r\n  width: 32px;\r\n  height: 32px;\r\n  padding: 0;\r\n  border: none;\r\n  position: absolute;\r\n  top: -40px;\r\n  right: -40px;\r\n  background: transparent url(../../images/btnCloseLight.svg) no-repeat center;\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .card-popup__btn-close {\r\n    right: 0;\r\n  }\r\n  .card-popup__wrapper {\r\n    max-width: 75vw;\r\n    padding: 4px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
